import { render } from "./AttendanceRequest.vue?vue&type=template&id=85b181ce&ts=true"
import script from "./AttendanceRequest.vue?vue&type=script&lang=ts"
export * from "./AttendanceRequest.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__